export const translateMessage = async (authToken, message, typeOfClientCall, source_lang = "auto", target_lang = "en") => {
const apiUrl = import.meta.env.VITE_API_URL;

  const body = {
    "typeOfClientCall": typeOfClientCall,
    "text": message,
    "source_lang": source_lang,
    "target_lang": target_lang
  }

  const params = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      'Authorization': authToken
    },
    body: JSON.stringify(body)
  }

  try {
    const response = await fetch(apiUrl, params);
    return response;
  } catch (e) {
    console.error('ERRR--------- :', e)
    throw new Error("ERREUR");
  }
}